const branches = {
  branches: {
    pageHeader: 'Branch Offices',
    addBranchOffice: '+ Add Branch Office',
    name: 'Name',
    city: 'City',
    state: 'State/Province',
    country: 'Country',
    branches: 'Branches',
    noBranchAvailable: '** No Branches Available **'
  }
};

export default branches;
